import { useTranslation } from '@mint-lib/i18n';
import { Alert } from '@mint-lib/tw-components/patterns';

import type { PlatformPermission } from '../../../types/platfroms.js';
import { PlatformChip } from './PlatformChip.jsx';

type Props = {
  platforms: PlatformPermission[];
};

const PlatformPermissions = ({ platforms }: Props) => {
  const { t } = useTranslation('@mint-lib/recommendations-circuit');

  const platformsStatus = platforms.map((platform) => ({
    ...platform,
    allPermissionsSame: platform.children.every(
      (child) => child.permission === platform.children[0]?.permission,
    ),
    platformPermission: platform.children[0]?.permission,
  }));

  const withoutEditPermission = platformsStatus.map((platform) => ({
    ...platform,
    children: platform.children.filter(
      (mediaRow) => mediaRow.permission !== 'read_and_write_level',
    ),
  }));

  if (!platforms.length) return null;

  return (
    <Alert removable={false} title={t('Please update your permissions')}>
      <div className="flex w-full flex-col gap-2">
        <p>
          {t(
            'Accepting recommendations requires read and write access for the following platforms',
          )}
        </p>
        <div className="flex w-full flex-col flex-wrap gap-2">
          {withoutEditPermission.map((platform) => {
            return platform.allPermissionsSame ? (
              <PlatformChip
                key={platform.id}
                label={platform.label}
                permission={platform.platformPermission}
                logo={platform.logo}
              />
            ) : (
              platform.children.map((mediaRow) => (
                <PlatformChip
                  key={mediaRow.id}
                  label={`${platform.label} - ${mediaRow.name}`}
                  permission={mediaRow.permission}
                  logo={platform.logo}
                />
              ))
            );
          })}
        </div>
      </div>
    </Alert>
  );
};

export { PlatformPermissions };
